import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ExportCsvService {

  exporter(nomFichier: string, colonnes: { header: string; key: string }[], donnees: any[]): void {
    const BOM = '﻿';
    const entete = colonnes.map(c => `"${c.header}"`).join(';');
    const lignes = donnees.map(d =>
      colonnes.map(c => `"${(d[c.key] ?? '').toString().replace(/"/g, '""')}"`).join(';')
    );
    const csv = BOM + [entete, ...lignes].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${nomFichier}_${this.dateTag()}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  private dateTag(): string {
    const d = new Date();
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;
  }
}
